module.exports = __webpack_public_path__ + "static/media/7day@2x.a446e2ca.png";